import { NotificationService } from 'src/app/services/notification.service';
import { GeneralService } from 'src/app/services/general.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralComponent } from 'src/app/shared/general.component';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { type } from 'os';
import { Console } from 'console';
import * as moment from 'moment';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-qua007-card-II',
    templateUrl: './qua007-card-II.component.html'
})

export class Qua007CardIIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    //public readyOnlyGeracao?: boolean;
    //public readyOnlyUmidade?: boolean;

    @Output() mkCalc = new EventEmitter();
    @Output() mkCalcI = new EventEmitter();
    @Output() mkCalcFxAzulUmidade = new EventEmitter();
    @Output() mkHarvestWeek = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected generalService: GeneralService, protected notificationService: NotificationService) {
        super('Etapa 2', false);
        if (this.isComercial || this.isBasica) {
            this.formulario = this.formBuilder.group({
                // Geracao: [null, []],
                // Especie: [null, []],
                // Tp_colheita: [null, []],
                Umidade: [null, []],
                Dt_colheita: [null, [Validators.pattern(this.regexDate)]],
                Termino_enchimento_data: [null, [Validators.minLength(8), Validators.pattern(this.regexDate)]],
                Termino_enchimento_hora: [null, [Validators.minLength(4), Validators.pattern(this.regexHour)]],
                Saida_campo_data: [null, [Validators.minLength(8), Validators.pattern(this.regexDate)]],
                Saida_campo_hora: [null, [Validators.minLength(4), Validators.pattern(this.regexHour)]],
                Tempo_espera_campo: [null, []],
                Resp_liberacao_colheita: [null, []],
            });
        }

        else {
            this.formulario = this.formBuilder.group({});
        }
    }

    ngOnInit(): void {
        //this.readyOnlyGeracao = true;
        //this.readyOnlyUmidade = true;
    }

    alertaData() {
        const dataAtual: any = moment(new Date());

        const dataColheita = moment(this.formulario.get('Dt_colheita')?.value as string, 'DD/MM/YYYY');
        const dataTerminoEnchimento = moment(this.formulario.get('Termino_enchimento_data')?.value as string, 'DD/MM/YYYY');
        const dataSaidaCampo = moment(this.formulario.get('Saida_campo_data')?.value as string, 'DD/MM/YYYY');

        const diffColheita = Math.abs(dataAtual.diff(dataColheita, 'days'));
        const diffTerminoEnchimento = Math.abs(dataAtual.diff(dataTerminoEnchimento, 'days'));
        const diffSaidaCampo = Math.abs(dataAtual.diff(dataSaidaCampo, 'days'));

        console.log(`dataAtual ${dataAtual}`);

        console.log(`diffColheita ${diffColheita}`)
        console.log(`diffTerminoEnchimento ${diffTerminoEnchimento}`)
        console.log(`diffSaidaCampo ${diffSaidaCampo}`)


        if (diffColheita > 7 || diffTerminoEnchimento > 7 || diffSaidaCampo > 7) {
            console.log('entrou no if')
            this.notificationService.sendNotification('', TypeMessage.DiffDias, ActionMessage.Warning);
        }
    }

    changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }

    async makeFxAzulUmidadeCalc(): Promise<void> {
        this.mkCalcFxAzulUmidade.emit();
    }

    async calcHarvestWeek(): Promise<void> {
        this.mkHarvestWeek.emit();
    }

    async makeCalculationsI(): Promise<void> {
        this.mkCalcI.emit();
    }
}
